import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalInfoCertificationProps {
  open: boolean;
  onClose: (open: boolean) => void;
  amountCertifate?: string;
  amountTotal?: string;
}

const ModalInfoCertification = ({
  open,
  onClose,
  amountCertifate,
  amountTotal,
}: ModalInfoCertificationProps): React.ReactElement => {
  const formContext = useFormikContext<CertificateFormVM>();

  const nameCertificate = useMemo(() => {
    let name = 'Contestuale';

    if (!formContext.values.certificateAnpr?.length) {
      name = '';
    }

    if (formContext.values?.certificateAnpr?.length === 1) {
      name = formContext.values?.certificateAnpr[0].descrizioneTipoDocumento;
    }

    return name;
  }, [formContext.values.certificateAnpr]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        Emesso certificato <b>{nameCertificate}</b> per un importo di <b>{amountCertifate}</b> euro.{' '}
        <br />
        Totale per certificati emessi <b>{amountTotal}</b> euro.
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="outlined"
          color="cdmBrandThird"
          type="button"
          onClick={() => onClose(false)}
        >
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalInfoCertification.displayName = 'Modal info certification';

export default ModalInfoCertification;
